import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-container">

      <div className="footer-content">
        {/* About Us Section */}
        <div className="footer-section about">
          <h2>About Varankal</h2>
          <p>
            Varankal Matrimony is a most trusted matrimonial platform dedicated to helping people find their ideal life partners.
            With verified profiles and advanced matchmaking, we ensure a seamless and secure experience.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h2>Our Services</h2>
          <ul className="footer-list">
            <li><span className="arrow-icon">➤</span> <Link to="/Blogs" onClick={() => window.scrollTo(0, 0)}>Blogs</Link></li>
            <li><span className="arrow-icon">➤</span> <Link to="/aboutus" onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
            <li><span className="arrow-icon">➤</span> <Link to="/review" onClick={() => window.scrollTo(0, 0)}>User Reviews</Link></li>
            <li><span className="arrow-icon">➤</span> <Link to="/successstory" onClick={() => window.scrollTo(0, 0)}>Success Stories</Link></li>
            <li><span className="arrow-icon">➤</span> <Link to="/subscription" onClick={() => window.scrollTo(0, 0)}>Subscription Plans</Link></li>

          </ul>
        </div>

        {/* Our Services */}
        <div className="footer-section">
          <h2>Quick Links</h2>
          <ul className="footer-list">
            <li><span className="arrow-icon">➤</span> <Link to="/VarankalFAQ" onClick={() => window.scrollTo(0, 0)}>FAQ's</Link></li>
            <li><span className="arrow-icon">➤</span> <Link to="/submitrequest" onClick={() => window.scrollTo(0, 0)}>Report</Link></li>
            <li><span className="arrow-icon">➤</span> <Link to="/disclaimer" onClick={() => window.scrollTo(0, 0)}>Disclaimer</Link></li>
            <li><span className="arrow-icon">➤</span> <Link to="/privacypolicy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link></li>
            <li><span className="arrow-icon">➤</span> <Link to="/legalview" onClick={() => window.scrollTo(0, 0)}>Terms & Conditions</Link></li>

          </ul>
        </div>

        {/* Contact & Support */}
        <div className="footer-section">
          <h2>Branches</h2>
          <ul className="footer-list">
            <li><span className="arrow-icon">➤</span>Trichy</li>
            <li><span className="arrow-icon">➤</span>Salem</li>
            <li><span className="arrow-icon">➤</span>Vellore</li>
            <li><span className="arrow-icon">➤</span>Chennai</li>
            <li><span className="arrow-icon">➤</span>Madurai</li>
          </ul>
        </div>
      </div>

      {/* Social Media & Payment Methods */}
      <div className="footer-bottom">
        <div className="social-media">
          <h2>Follow Us</h2>
          <ul className="social-icons">
            <li><Link to="https://www.facebook.com/checkpoint/1501092823525282/"><FaFacebookF /></Link></li>
            <li><Link to="https://x.com/varankal"><FaTwitter /></Link></li>
            <li><Link to="https://www.instagram.com/varan_kal/"><FaInstagram /></Link></li>
            <li><Link to="https://www.youtube.com/@Varankal_Matrimony"><FaYoutube /></Link></li>
          </ul>
        </div>
        <div className="footer-sectionL33 newsletterL33">
          <h2 className="footer-headingL33">Stay Updated</h2>
          <p className="footer-textL33">Subscribe to receive exclusive updates.</p>
          <form className="footer-formL33">
            <input type="email" className="footer-inputL33" placeholder="Enter your email" required />
            <button type="submit" className="footer-buttonL33">Subscribe</button>
          </form>
        </div>

        <div className="payment-methods">
          <h2>We Accept</h2>
          <p>Visa | Vpay | UPI</p>
        </div>
      </div>
      <hr></hr>

      {/* Copyright Notice */}
      <div className="footer-copy9878">
        <p>© {new Date().getFullYear()} Varankal. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
